import { Box } from '@mui/material';
import { DynamicPageConfig, TemplateType } from 'compobot-dynamic-page';
import { Control, FieldErrors } from 'react-hook-form';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import FormContent from './FormContent';
import DynamicPagePreview from './preview/DynamicPagePreview';

interface MobileLayoutProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
  onSubmit: () => void;
  isEditMode?: boolean;
  useCustomPageParams?: boolean;
  setUseCustomPageParams?: (value: boolean) => void;
  previewConfig: DynamicPageConfig;
  selectedTemplate: TemplateType;

  // Word counters
  pretextEnCount: number;
  pretextHuCount: number;
  setPretextEnCount: (count: number) => void;
  setPretextHuCount: (count: number) => void;
  titleEnCount: number;
  titleHuCount: number;
  setTitleEnCount: (count: number) => void;
  setTitleHuCount: (count: number) => void;
  subtitleEnCount: number;
  subtitleHuCount: number;
  setSubtitleEnCount: (count: number) => void;
  setSubtitleHuCount: (count: number) => void;

  // Color props
  colors: {
    pretext: string;
    title: string;
    subtitle: string;
    overlay: string;
  };
  onPretextColorChange: (color: string) => void;
  onTitleColorChange: (color: string) => void;
  onSubtitleColorChange: (color: string) => void;
  onOverlayColorChange: (color: string) => void;
}

export default function MobileLayout({
  control,
  errors,
  onSubmit,
  isEditMode = false,
  useCustomPageParams = true,
  setUseCustomPageParams,
  previewConfig,
  selectedTemplate,
  pretextEnCount,
  pretextHuCount,
  setPretextEnCount,
  setPretextHuCount,
  titleEnCount,
  titleHuCount,
  setTitleEnCount,
  setTitleHuCount,
  subtitleEnCount,
  subtitleHuCount,
  setSubtitleEnCount,
  setSubtitleHuCount,
  colors,
  onPretextColorChange,
  onTitleColorChange,
  onSubtitleColorChange,
  onOverlayColorChange,
}: MobileLayoutProps) {
  return (
    <Box display="flex" flexDirection="column">
      {/* Preview at top on mobile */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          mb: 2,
          py: 2,
          borderRadius: 1,
        }}
      >
        <DynamicPagePreview
          config={previewConfig}
          theme={selectedTemplate}
          currentLanguage="en"
        />
      </Box>

      {/* Form below on mobile */}
      <Box sx={{ px: 1 }}>
        <FormContent
          control={control}
          errors={errors}
          onSubmit={onSubmit}
          isEditMode={isEditMode}
          useCustomPageParams={useCustomPageParams}
          setUseCustomPageParams={setUseCustomPageParams}
          pretextEnCount={pretextEnCount}
          pretextHuCount={pretextHuCount}
          setPretextEnCount={setPretextEnCount}
          setPretextHuCount={setPretextHuCount}
          titleEnCount={titleEnCount}
          titleHuCount={titleHuCount}
          setTitleEnCount={setTitleEnCount}
          setTitleHuCount={setTitleHuCount}
          subtitleEnCount={subtitleEnCount}
          subtitleHuCount={subtitleHuCount}
          setSubtitleEnCount={setSubtitleEnCount}
          setSubtitleHuCount={setSubtitleHuCount}
          colors={colors}
          onPretextColorChange={onPretextColorChange}
          onTitleColorChange={onTitleColorChange}
          onSubtitleColorChange={onSubtitleColorChange}
          onOverlayColorChange={onOverlayColorChange}
        />
      </Box>
    </Box>
  );
}
